import {
  GET_CURRENT_COURSE,
  GET_CURRENT_COURSE_SUCCESS,
  GET_CURRENT_COURSE_FAILURE,
  OPEN_DRAWER,
  CLOSE_DRAWER,
  CREATE_COURSE_SUCCESS,
  ADD_COMMANDS_SUCCESS,
  CANCEL_COURS_SUCCESS
} from './courseActions';

const initialState = {
  currentCourse: null,
  openDrawer: false,
  courseWatch: false
};
/**
 * Course reducer
 */
const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_COURSE:
      return {
        ...state
      };
    case GET_CURRENT_COURSE_SUCCESS:
      return {
        ...state,
        currentCourse: action.payload
      };
    case GET_CURRENT_COURSE_FAILURE:
      return {
        ...state
      };
    case OPEN_DRAWER:
      return {
        ...state,
        openDrawer: true,
        allCommands: action.payload.allCommands
      };
    case CLOSE_DRAWER:
      return {
        ...state,
        openDrawer: false,
        allCommands: false
      };
    case CREATE_COURSE_SUCCESS:
      return {
        ...state,
        openDrawer: false,
        courseWatch: !state.courseWatch
      };
    case CANCEL_COURS_SUCCESS:
      return {
        ...state,
        courseWatch: !state.courseWatch
      };
    case ADD_COMMANDS_SUCCESS:
      return {
        ...state,
        openDrawer: false,
        courseWatch: !state.courseWatch
      };
    default:
      return state;
  }
};

export default courseReducer;
